export default function menu() {
  $(document).ready(function() {
    //troca de img na Home
    var i = 1
    setInterval(function() {
      if (i <= 13) {
        $('section.pet-space-call div.container div.illustration.dog img').attr('src', './assets/img/pet-space-call-' + i + '.png')
        i++
      } else {
        i = 1
      }
    }, 3000)

    http: $('section.pet-space div.list ul li div.content > div.text button').click(function() {
      $(this)
        .closest('section.pet-space div.list ul li div.content')
        .find('div.text')
        .toggleClass('show')
      $(this)
        .closest('section.pet-space div.list ul li')
        .find('div.illustration')
        .toggleClass('scale')
    })

    $('section.pet-space div.list ul li div.content > div.column button').click(function() {
      $(this)
        .closest('section.pet-space div.list ul li div.content')
        .find('div.text')
        .toggleClass('show')
      $(this)
        .closest('section.pet-space div.list ul li')
        .find('div.illustration')
        .toggleClass('scale')
    })

    var button = $('.pet-space .list > button')
    var post = $('.pet-space .list ul li')
    var current = $('.pet-space .list ul li').filter(function() {
      return $(this).css('display') === 'block'
    }).length

    if (post.length <= current) {
      button.css({
        display: 'none',
        background: 'white',
        border: 'none',
      })
    }

    button.on('click', function() {
      for (var e = current; e < current + 4; e++) {
        if (post.eq(e)) {
          post.eq(e).css('display', 'block')
        }
      }
      current += 4
      if (current >= post.length) {
        button.fadeOut()
      }
    })
  })
}
